// Performance & telemetry reporting for AEGIS frontend console

export const reportMetrics = () => {
  if (typeof window === 'undefined') return;

  // Page load timing
  if (window.performance && window.performance.timing) {
    const timing = window.performance.timing;
    const loadTime = timing.loadEventEnd - timing.navigationStart;
    const domReady = timing.domContentLoadedEventEnd - timing.navigationStart;
    
    if (loadTime > 0) {
      console.log(`[AEGIS Performance] Page Load: ${loadTime}ms | DOM Content Loaded: ${domReady}ms`);
    }
  }

  // Paint and Navigation Observer
  if (typeof window.PerformanceObserver !== 'undefined') {
    try {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'paint') {
            console.log(`[AEGIS Performance] ${entry.name}: ${Math.round(entry.startTime)}ms`);
          }
        }
      });
      observer.observe({ entryTypes: ['paint'] });
    } catch {
      // PerformanceObserver fallback for older engines
    }
  }
};
